import { render, staticRenderFns } from "./DmrTeams.vue?vue&type=template&id=3ec28972&scoped=true"
import script from "./DmrTeams.vue?vue&type=script&lang=js"
export * from "./DmrTeams.vue?vue&type=script&lang=js"
import style0 from "./DmrTeams.vue?vue&type=style&index=0&id=3ec28972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec28972",
  null
  
)

export default component.exports